export default __webpack_public_path__ + "static/media/Create-documentation.1e74e0aa.md";